import { Injectable } from '@angular/core';
import { Router, Params } from '@angular/router';
import { AuthenticationService } from '../../shared/services/api/authentication/authentication.service';
import { ApiService } from '../../shared/services/api/api.service';
import { UserSessionStore } from '../../shared/services/user-session.store';
import { MainModuleManagerService } from '../../shared/services/module-manager.service';
import { isEmpty } from 'lodash';

@Injectable({ providedIn: 'root' })
export class LoginHelperService {
  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private apiService: ApiService,
    private sessionStore: UserSessionStore,
    private mainModuleManagerService: MainModuleManagerService
  ) {}

  async login(email: string, password: string, captcha: string): Promise<void> {
    await this.authService.login(email, password, captcha);
    this.apiService.exStatistics.setAccountInfos();
    this.apiService.exStatistics.setExplainStatistics();
  }

  async navigateAfterLogin(returnUrl?: string, returnQueryParams?: Params): Promise<void> {
    if (returnUrl) {
      await this.router.navigate([returnUrl], { queryParams: returnQueryParams });
      return;
    }

    const modules = this.sessionStore.userSession()?.modules ?? [];
    const route = this.mainModuleManagerService.getPostLoginRoute(modules);
    await this.router.navigate([route]);
  }

  parseReturnUrl(params: Params): { returnUrl: string; returnQueryParams: Params } {
    let returnUrl = '/';
    const returnQueryParams: Params = {};

    if (isEmpty(params)) {
      return { returnUrl, returnQueryParams };
    }

    const fromUrlParts = params['fromUrl']?.split('?') ?? [];
    if (fromUrlParts.length) {
      returnUrl = fromUrlParts[0];
      const urlSearchParams = new URLSearchParams(fromUrlParts[1]);
      for (const [key, value] of urlSearchParams.entries()) {
        returnQueryParams[key] = value;
      }
    } else {
      returnUrl = params['fromUrl'] || '/';
    }

    return { returnUrl, returnQueryParams };
  }
}
